export const eventMutationKeys = {
  all: ["EVENT_DETAIL"],
  mutateEventComments: (options?: string[]) => [
    ...eventMutationKeys.all,
    "COMMENTS",
    ...(options || []),
  ],
  mutateCommentReplies: (options?: string[]) => [
    ...eventMutationKeys.all,
    "COMMENTS_REPLIES",
    ...(options || []),
  ],
};
